import { TextFieldProps } from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import { FieldProps, getIn, useFormikContext } from "formik";
import React from "react";

interface Props {
  handleChange?: (value: string) => void;
  disabled?: boolean;
}

const FormikTimePicker: React.FC<FieldProps & TextFieldProps & Props> = (
  props
) => {
  const {
    handleChange: onTimeSelected,
    disabled,
    error,
    form,
    field,
    required,
    ...rest
  } = props;
  const { setFieldValue } = useFormikContext();
  const isTouched = getIn(form.touched, field.name);
  const errorMessage = getIn(form.errors, field.name);

  const handleChange = (value: any) => {
    setFieldValue(field.name, value);
    onTimeSelected?.(value);
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimePicker
        label={props.label}
        value={field.value}
        disabled={disabled}
        disableOpenPicker={disabled}
        onChange={handleChange}
        slotProps={{
          textField: {
            ...rest,
            fullWidth: true,
            error: error ?? Boolean(isTouched && errorMessage),
            required: required,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default FormikTimePicker;
